import React from 'react';
import { FieldProps } from 'formik';
import { FormControl, InputLabel, FormHelperText, FormControlProps } from '@material-ui/core';
import FormikSelect from './FormikSelect';

export default function FormikSelectControl({
    field,
    form,
    meta,
    children,
    cls,
    onChange,
    ...props
}: FieldProps &
    React.PropsWithChildren<any> &
    FormControlProps & { label: string; labelId: string; cls?: string }) {
    const showError = meta.touched && meta.error;
    return (
        <FormControl className={cls}>
            <InputLabel id={props.labelId} error={showError}>
                {props.label}
            </InputLabel>
            <FormikSelect
                labelId={props.labelId}
                meta={meta}
                form={form}
                field={field}
                error={showError}
                variant={props.variant}
                onChange={onChange}
                {...props}
            >
                {children}
            </FormikSelect>
            {showError && <FormHelperText error={!!showError}>{meta.error}</FormHelperText>}
        </FormControl>
    );
}
